import React from "react";
import { Col, Form, Row } from "react-bootstrap";
import Carrier from "./Carrier";
import AirportDeparture from "./AirportDeparture ";
import AirportDestination from "./AirportDestination ";
import TimeDeparture from "./TimeDeparture";
import TimeArrival from "./TimeArrival";

const FlightLegs = ({
  index,
  values,
  touched,
  errors,
  handleChange,
  handleBlur,
  valueState,
  suggestions,
  setSuggestions,
  isSelectSuggestion,
  changeInput,
  airlineDetails,
  departureValue,
  airportDetails,
  changeDepartureInput,
  departureSelected,
  depSuggestions,
  setDepSuggestions,
  destinationValue,
  changeDestinationInput,
  destinationSelected,
  desSuggestion,
  setDesSuggestion,
  timeDeparture,
  changeTimeDepartureInput,
  timeArrival,
  changeTimeArrivalInput,
  tripType,
}) => {
  return (
    <>
      {index > 0 && <hr />}
      <Form.Label className="heading2 lead d-none">Leg {index + 1}</Form.Label>
      <Row>
        <Col xs="12" md="6" lg={tripType === 2 ? "6" : "3"}>
          <Form.Group className="mb-3" controlId="formBasicEmail">
            <Form.Label className="heading">
              Flight Number<span className="text-danger">*</span>
            </Form.Label>
            <Form.Control
              type="text"
              placeholder=""
              name={`flightLegs.return[${index}].flightNumber`}
              value={values.flightLegs.return[index].flightNumber}
              onChange={handleChange}
              error={
                errors.flightLegs &&
                errors.flightLegs.return &&
                errors.flightLegs.return[index] &&
                errors.flightLegs.return[index].flightNumber
              }
              isInvalid={
                touched.flightLegs &&
                touched.flightLegs.return &&
                touched.flightLegs.return[index] &&
                errors.flightLegs &&
                errors.flightLegs.return &&
                errors.flightLegs.return[index] &&
                touched.flightLegs.return[index].flightNumber &&
                errors.flightLegs &&
                errors.flightLegs.return &&
                !!errors.flightLegs.return[index].flightNumber
              }
              touched={
                touched.flightLegs &&
                touched.flightLegs.return &&
                touched.flightLegs.return[index] &&
                touched.flightLegs.return[index].flightNumber
              }
              onBlur={handleBlur}
            />
            <Form.Control.Feedback type="invalid">
              {touched.flightLegs &&
                touched.flightLegs.return &&
                touched.flightLegs.return[index] &&
                errors.flightLegs &&
                errors.flightLegs.return &&
                errors.flightLegs.return[index] &&
                touched.flightLegs.return[index].flightNumber &&
                errors.flightLegs.return[index].flightNumber}
            </Form.Control.Feedback>
          </Form.Group>
        </Col>
        <Col xs="12" md="6" lg={tripType === 2 ? "6" : "3"}>
          <Form.Group className="mb-3" controlId="formBasicEmail">
            <Form.Label className="heading">
              Carrier<span className="text-danger">*</span>
            </Form.Label>
            <Carrier
              index={index}
              valueState={valueState}
              suggestions={suggestions}
              setSuggestions={setSuggestions}
              isSelectSuggestion={isSelectSuggestion}
              changeInput={changeInput}
              airlineDetails={airlineDetails}
            />
          </Form.Group>
        </Col>
        <Col xs="12" md="6" lg={tripType === 2 ? "6" : "3"}>
          <Form.Group className="mb-3" controlId="formBasicEmail">
            <Form.Label className="heading">
              Airport Departure<span className="text-danger">*</span>
            </Form.Label>
            <AirportDeparture
              index={index}
              departureValue={departureValue}
              airportDetails={airportDetails}
              changeDepartureInput={changeDepartureInput}
              departureSelected={departureSelected}
              depSuggestions={depSuggestions}
              setDepSuggestions={setDepSuggestions}
            />
            {/* <Form.Control.Feedback type="invalid">
              {touched.flightLegs && touched.flightLegs.return &&
                touched.flightLegs.return[index] &&
                errors.flightLegs && errors.flightLegs.return &&
                errors.flightLegs.return[index] &&
                touched.flightLegs.return[index].airportDepartureId &&
                errors.flightLegs.return[index].airportDepartureId}
            </Form.Control.Feedback> */}
          </Form.Group>
        </Col>
        <Col xs="12" md="6" lg={tripType === 2 ? "6" : "3"}>
          <Form.Group className="mb-3" controlId="formBasicEmail">
            <Form.Label className="heading">
              Airport Destination<span className="text-danger">*</span>
            </Form.Label>
            <AirportDestination
              index={index}
              destinationValue={destinationValue}
              airportDetails={airportDetails}
              changeDestinationInput={changeDestinationInput}
              destinationSelected={destinationSelected}
              desSuggestion={desSuggestion}
              setDesSuggestion={setDesSuggestion}
            />
            {/* <Form.Control.Feedback type="invalid">
              {touched.flightLegs && touched.flightLegs.return &&
                touched.flightLegs.return[index] &&
                errors.flightLegs && errors.flightLegs.return &&
                errors.flightLegs.return[index] &&
                touched.flightLegs.return[index].airportDestinationId &&
                errors.flightLegs.return[index].airportDestinationId}
            </Form.Control.Feedback> */}
          </Form.Group>
        </Col>
      </Row>

      <Row>
        <Col xs="12" md="6" lg={tripType === 2 ? "6" : "3"}>
          <Form.Group className="mb-3" controlId="formBasicEmail">
            <Form.Label className="heading">
              Time Departure<span className="text-danger">*</span>
            </Form.Label>
            <TimeDeparture
              index={index}
              timeDeparture={timeDeparture}
              changeTimeDepartureInput={changeTimeDepartureInput}
              touched={touched}
            />
            {/*             
            <Form.Control.Feedback type="invalid">
              {touched.flightLegs && touched.flightLegs.return &&
                touched.flightLegs.return[index] &&
                errors.flightLegs && errors.flightLegs.return &&
                errors.flightLegs.return[index] &&
                touched.flightLegs.return[index].departureTime &&
                errors.flightLegs.return[index].departureTime}
            </Form.Control.Feedback> */}
          </Form.Group>
        </Col>
        <Col xs="12" md="6" lg={tripType === 2 ? "6" : "3"}>
          <Form.Group className="mb-3" controlId="formBasicEmail">
            <Form.Label className="heading">
              Time Arrival<span className="text-danger">*</span>
            </Form.Label>
            <TimeArrival
              index={index}
              timeArrival={timeArrival}
              changeTimeArrivalInput={changeTimeArrivalInput}
              touched={touched}
            />

            {/* <Form.Control.Feedback type="invalid">
              {touched.flightLegs && touched.flightLegs.return &&
                touched.flightLegs.return[index] &&
                errors.flightLegs && errors.flightLegs.return &&
                errors.flightLegs.return[index] &&
                touched.flightLegs.return[index].arrivalTime &&
                errors.flightLegs.return[index].arrivalTime}
            </Form.Control.Feedback> */}
          </Form.Group>
        </Col>
        <Col xs="12" md="6" lg={tripType === 2 ? "6" : "3"}>
          <Form.Group className="mb-3" controlId="formBasicEmail">
            <Form.Label className="heading">
              Check In Baggage<span className="text-danger">*</span>
            </Form.Label>
            <Form.Control
              type="text"
              placeholder=""
              name={`flightLegs.return[${index}].checkInBaggage`}
              value={values.flightLegs.return[index].checkInBaggage}
              error={
                errors.flightLegs &&
                errors.flightLegs.return &&
                errors.flightLegs.return[index] &&
                errors.flightLegs.return[index].checkInBaggage
              }
              onChange={handleChange}
              isInvalid={
                touched.flightLegs &&
                touched.flightLegs.return &&
                touched.flightLegs.return[index] &&
                touched.flightLegs.return[index].checkInBaggage &&
                errors.flightLegs &&
                errors.flightLegs.return &&
                errors.flightLegs.return[index] &&
                !!errors.flightLegs.return[index].checkInBaggage
              }
              touched={
                touched.flightLegs &&
                touched.flightLegs.return &&
                touched.flightLegs.return[index] &&
                touched.flightLegs.return[index].checkInBaggage
              }
              onBlur={handleBlur}
            />
            <Form.Control.Feedback type="invalid">
              {touched.flightLegs &&
                touched.flightLegs.return &&
                touched.flightLegs.return[index] &&
                errors.flightLegs &&
                errors.flightLegs.return &&
                errors.flightLegs.return[index] &&
                touched.flightLegs.return[index].checkInBaggage &&
                errors.flightLegs.return[index].checkInBaggage}
            </Form.Control.Feedback>
          </Form.Group>
        </Col>
        <Col xs="12" md="6" lg={tripType === 2 ? "6" : "3"}>
          <Form.Group className="mb-3" controlId="formBasicEmail">
            <Form.Label className="heading">
              Fare Type<span className="text-danger">*</span>
            </Form.Label>
            <Form.Control
              type="text"
              placeholder=""
              name={`flightLegs.return[${index}].fareType`}
              value={values.flightLegs.return[index].fareType}
              error={
                errors.flightLegs &&
                errors.flightLegs.return &&
                errors.flightLegs.return[index] &&
                errors.flightLegs.return[index].fareType
              }
              onChange={handleChange}
              isInvalid={
                touched.flightLegs &&
                touched.flightLegs.return &&
                touched.flightLegs.return[index] &&
                touched.flightLegs.return[index].fareType &&
                errors.flightLegs &&
                errors.flightLegs.return &&
                errors.flightLegs.return[index] &&
                !!errors.flightLegs.return[index].fareType
              }
              touched={
                touched.flightLegs &&
                touched.flightLegs.return &&
                touched.flightLegs.return[index] &&
                touched.flightLegs.return[index].fareType &&
                touched.flightLegs.return[index].fareType
              }
              onBlur={handleBlur}
            />

            <Form.Control.Feedback type="invalid">
              {touched.flightLegs &&
                touched.flightLegs.return &&
                touched.flightLegs.return[index] &&
                errors.flightLegs &&
                errors.flightLegs.return &&
                errors.flightLegs.return[index] &&
                touched.flightLegs.return[index].fareType &&
                errors.flightLegs.return[index].fareType}
            </Form.Control.Feedback>
          </Form.Group>
        </Col>
      </Row>
    </>
  );
};

export default FlightLegs;
